var config = {
  unit: 'px',
  width: {
    m: 700,
    l: 1100,
    xl: 1500
  }
};

export { config };
//# sourceMappingURL=config.js.map
